var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSectionTwo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 250,
    viewBox: "0 0 486 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.5 14.2437L331.5 166.5L14.1586 166.5C10.5371 166.5 7.06329 165.053 4.50155 162.476C1.93972 159.898 0.499993 156.402 0.499993 152.756L0.5 0.500001L317.841 0.500015C321.463 0.500015 324.937 1.94728 327.498 4.52439C330.06 7.10161 331.5 10.5977 331.5 14.2437Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M485.5 97.2437L485.5 249.5L167.201 249.5C163.568 249.5 160.083 248.052 157.514 245.475C154.944 242.898 153.5 239.402 153.5 235.756L153.5 83.5L471.799 83.5C475.432 83.5 478.917 84.9476 481.486 87.5249C484.056 90.1022 485.5 93.5982 485.5 97.2437Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionTwo2);
export default __webpack_public_path__ + "static/media/section_two_2.a09e38208de99d70d2794a9d7cfef845.svg";
export { ForwardRef as ReactComponent };